export class GeoLocationRequest {
    Latitude?: number;
    Longitude?: number;
    Accuracy: number | null;
    Altitude: number | null;
    AltitudeAccuracy: number | null;
    Heading: number | null;
    Speed: number | null;
    ZipCode: string;
    PageSize?: number;

    constructor(init?: Partial<GeoLocationRequest>) {
        Object.assign(this, init);
    }
}
